import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
	setGridViewInStore: ["gridType"]
});

export { Creators, Types };
